import { eventsConstants } from '../constants';

export const eventsReducer = (state = {}, action) => {
    switch(action.type) {
        case eventsConstants.GET_ALL_EVENTS_DATA_REQUEST:
            return {
                ...state,
                getAllEventsProcess: true   
            }

        case eventsConstants.GET_ALL_EVENTS_DATA_SUCCESS:
            const list = action.payload.reduce((result, item) => {
                result[item._id] = item;
                return result;
            }, {});
            
            return {
                ...state,
                list: {...state.list, ...list},
                getAllEventsProcess: false,
                getAllEventsError: false
            }

        case eventsConstants.GET_ALL_EVENTS_DATA_FAILURE:
            return {
                ...state,
                getAllEventsProcess: false,
                getAllEventsError: true
            }

        case eventsConstants.GET_EVENT_DATA_REQUEST:
            return {
                ...state,
                getEventProcess: true   
            }

        case eventsConstants.GET_EVENT_DATA_SUCCESS:
            return {
                ...state,
                list: {...state.list, ...action.payload},
                getEventProcess: false,
                getEventError: false
            }

        case eventsConstants.GET_EVENT_DATA_FAILURE:
            return {
                ...state,
                getEventProcess: false,
                getEventError: true
            }

        case eventsConstants.UPDATE_EVENT_DATA_REQUEST:
            return {
                ...state,
                updateEventProcess: true   
            }

        case eventsConstants.UPDATE_EVENT_DATA_SUCCESS:
            return {
                ...state,
                list: {...state.list, ...action.payload},
                updateEventProcess: false,
                updateEventError: false
            }

        case eventsConstants.UPDATE_EVENT_DATA_FAILURE:
            return {
                ...state,
                updateEventProcess: false,
                updateEventError: true
            }

        case eventsConstants.SET_CURRENT_EVENT_ID:
            return {
                ...state,
                currentEventID: action.payload
            }

        case eventsConstants.UNSET_CURRENT_EVENT_ID:
            return {
                ...state,
                currentEventID: undefined
            }

        default:
            return state;
    }
}

export default eventsReducer;


// WEBPACK FOOTER //
// ./src/reducers/events.js